<div class="wrapper text-center pt-5" data-test-id="wrap-users-total">
  <div class="d-flex flex-wrap">
    <div
      *ngFor="let preset of iconPresets[statistics.statistic_type]"
      [attr.data-test-id]="'wrap_' + preset"
      class="col w-100 ps-2 pe-2"
    >
      <div class="img-holder mb-2">
        <svg-icon
          [src]="mapStatisticsIconsLookup[preset].icon.path"
          [ngClass]="
            iconPresets[statistics.statistic_type].length > 3
              ? 'icon-95'
              : 'mapStatisticsIconsLookup[preset].icon.class'
          "
          [attr.data-test-id]="preset + '_icon'"
        >
        </svg-icon>
      </div>
      <span class="total text-muted" [attr.data-test-id]="preset + '_counter'">
        {{ statistics.statistic_counters[preset] | number }}
      </span>
      <h2 class="text-uppercase mb-5" [attr.data-test-id]="preset + '_title'">
        {{
          mapStatisticsIconsLookup[preset].title | pluralStatistics: statistics.statistic_counters[preset] | translate
        }}
      </h2>
    </div>
  </div>
</div>
<div class="statistics-info-updated" *ngIf="!flags.isNotCovidTab">
  <span class="statistics-info-updated-data" data-test-id="info-statistics-update">
    {{ 'MAP_STATISTICS_TITLE_COVID_UPDATED' | translate }}:
    {{ statistics.statistic_counters[infoUpdate] | date: formatDate }}
  </span>
</div>
